/**
 * Ordenación personalizada sobre una serie de objetos mountain
 * debe implemtarse aquí.
 * 
 * De forma específica se utiliza sobre las tablas de cumbres.
 *  
 * La motivación principal es que la ordenación por defecto no
 * cubre ciertos campos específicos como la categoría.
 * 
 * La ordenación por categorías de cumbres debe realizarse de acuerdo
 * con el criterio siguiente:
 * 
 * 1+ > 1 > 1- > 2+ > 2 > 2- > 3+ > 3 > 3-
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2023-2026 Mendikat
 * @license Mendikat
 *
 *
 */

export default {
    methods: {
        /**
         * Compara dos valores para ordenarlos en la tabla de cumbres
         *
         * @param {Object} a       Es un objeto montaña
         * @param {Object} b       Es otro objeto montaña
         * @param {string} key     La clave a ordenar es el campo específico
         *                         de ordenación.
         *
         * @returns {number|null}  Devuelve un número negativo si a debe
         *                         ir antes que b, un número positivo si
         *                         a debe ir después que b, o null si no
         *                         se debe ordenar por defecto.
         */
        sortCompare: function (a, b, key) {
            // Si la clave no es 'category', se utilizar el orden por defecto
            if ('category' !== key) return null;

            // Ordenación personalizada para la categoría
            const categoryOrder =
            {
                '1+': 1, '1': 2, '1-': 3,
                '2+': 4, '2': 5, '2-': 6,
                '3+': 7, '3': 8, '3-': 9,
            };

            // Accedemos a los objetos como un array
            /** @type {string} */
            const aCategory = a[key];
            /** @type {string} */
            const bCategory = b[key];

            return categoryOrder[aCategory] - categoryOrder[bCategory];
        },
    }
};
